import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  @Input() deviceXs:boolean;
  img:string="assets/images/Avis_Budget_Group-Logo.wine.png";
}
